import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/estructura-organizacional/candidatos';
/**
 * GET
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCandidatos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getCandidato = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */

export const postCandidato = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchCandidato = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteCandidato = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

export const autorizarCandidato = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET - Catálogo de Estados de Candidato
 * @returns {Promise<object[]>}
 */
export const getEstadosCandidato = async () => {
  try {
    const response = await API.get('/catalogos/estados-de-candidatos/');
    return response.data || [];
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Candidato vista optimized
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCandidatovistaOptimized = async (params) => {
  try {
    const response = await API.get('/estructura-organizacional/candidatos-optimized/', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};
export const putAutorizarContratacionDirecta = async (id) => {
  try {
    const payload = [
      {
        id: Number(id),
        tipo_de_contratacion_directa_id: 1,
      },
    ];

    const response = await API.put(
      '/estructura-organizacional/autorizar-contratacion-candidato/',
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );

    onSuccess(response, 'Contratación directa realizada correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    throw err;
  }
};

export const putAutorizarContratacion = async (id) => {
  try {
    const payload = [
      {
        id: Number(id),
        tipo_de_contratacion_directa_id: 3,
      },
    ];

    const response = await API.put(
      '/estructura-organizacional/autorizar-contratacion-candidato/',
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );

    onSuccess(response, 'Contratación autorizada correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    throw err;
  }
};
